import { isZeroValueString as n } from "./atoms-v2938.js";
function t(r) {
  return typeof r == "number" ? r === 0 : r !== null ? r === "none" || r === "0" || n(r) : !0;
}
export {
  t as isNone
};
